import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SeguridadService} from '@servicios/Seguridad.service';
import { EncuestaComponent } from './general/general.component';



const routes: Routes = [
    {path: '', redirectTo: 'colaborador', pathMatch: 'full'},
    {path: 'generarencuesta', component: EncuestaComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
  ];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EncuestaRoutingModule {}
